import { z } from "zod";
import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";

export const LetterSpacingUnit = z.enum(["Pixels", "Rem", "Percent"]);

export const LetterSpacingValue = z.object({
  unit: DimensionUnit,
  measure: z.number(),
});

export const LetterSpacingTokenData = tokenAliasOrValue(LetterSpacingValue);

export type LetterSpacingUnit = z.infer<typeof LetterSpacingUnit>;
export type LetterSpacingValue = z.infer<typeof LetterSpacingValue>;
export type LetterSpacingTokenData = z.infer<typeof LetterSpacingTokenData>;
